import React from "react";
import {
  CheckBox,
  DynamicDropdown,
  FileDownloader,
  StaticDropdown,
} from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import AllocationTableUI from "../StatusSummary/AllocationTableUI";
import {
  getPortfoGroupInventoryTable,
  getPortfoGroupInventoryExcel,
} from "src/Requests/portfolioGroups";
import type {
  IPortfoGroupInventorySearchParams,
  IPortfoGroupInventoryTableReport,
} from "src/Interfaces/portfolioGroups";
import { portfolioGroupExchangeTypeOptions } from "src/Utils/exchangeTypeOptions";
import PortfolioFilterMultiSelects from "../PortfolioFilterMultiSelects";
import { getPortfolioGroupInstrumentOptions } from "../portfolioGroupInstrumentOptions";

const NakedOptionSummary = () => {
  const [showHiddenCols, setShowHiddenCols] = React.useState(false);
  const [searchParams, setSearchParams] =
    React.useState<IPortfoGroupInventorySearchParams>({
      justOption: true,
      portfoGroupIds: [],
      accountIds: [],
      instrumentId: null,
      exchangeType: null,
    });

  const filterChangeHandler = (name: string, value: number | string) => {
    setSearchParams((prev) => ({
      ...prev,
      [name]:
        value === "" || value == null
          ? null
          : name === "instrumentId"
            ? String(value)
            : Number(value),
    }));
  };

  const multiSelectFilterChangeHandler = (
    name: "portfoGroupIds" | "accountIds",
    value: string[],
  ) => {
    setSearchParams((prev) => ({ ...prev, [name]: value.map(Number) }));
  };

  return (
    <div className="flex flex-col flex-1 w-full gap-3">
      <div className="flex flex-row justify-between items-end gap-3">
        <div className="flex flex-row justify-start items-end gap-3">
          <PortfolioFilterMultiSelects
            portfoGroupIds={searchParams.portfoGroupIds ?? []}
            accountIds={searchParams.accountIds ?? []}
            onChange={multiSelectFilterChangeHandler}
          />
          <div className="w-[220px]">
            <StaticDropdown
              dropdown={{
                name: "exchangeType",
                placeholder: "بورس",
                extraLabel: true,
              }}
              options={portfolioGroupExchangeTypeOptions}
              onChange={filterChangeHandler}
              value={searchParams.exchangeType?.toString() ?? ""}
            />
          </div>
          <div className="w-[220px]">
            <DynamicDropdown
              dropdown={{
                name: "instrumentId",
                placeholder: "نماد پایه یا آپشن",
                extraLabel: true,
              }}
              getData={getPortfolioGroupInstrumentOptions}
              onChange={filterChangeHandler}
              value={searchParams.instrumentId ?? ""}
            />
          </div>
          <div className="w-36">
            <FileDownloader getFile={() => getPortfoGroupInventoryExcel(searchParams)} />
          </div>
        </div>
      </div>
      <div className="min-h-8 flex items-center mb-2">
        <CheckBox
          checked={showHiddenCols}
          label="نمایش جزییات"
          name="showHiddenCols"
          onChange={(_, checked) => setShowHiddenCols(checked)}
        />
      </div>
      <div className="w-full flex justify-center">
        <TableTemplate<
          IPortfoGroupInventorySearchParams,
          IPortfoGroupInventoryTableReport
        >
          getDataTable={getPortfoGroupInventoryTable}
          searchParameters={searchParams}
          TableUI={({ reports, onAction, sortingType, setSortingType }) => (
            <AllocationTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              showHiddenCols={showHiddenCols}
              compactPercentAndExpandValue
              autoSizeAccountColumns
              tableBoxClassName="max-h-[800px] portfolio-group-first-row"
            />
          )}
          refreshTableTime={30000}
          pagesize={200}
          withSort
          tableWrapperClassname="!mx-0"
        />
      </div>
    </div>
  );
};

export default NakedOptionSummary;
